export default "__VITE_ASSET__Du1KoR62__"